/* External Imports */
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"

const AboutDeviSlide8 = ({ section }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      background={`#000 url(${config.imgPath}/d/46272/1684474033-ib_secion5bg.jpeg) no-repeat center top`}
      bgSize="cover !important"
      bgColor="#000"
      className={styles.section5Bg}
      overflow="hidden"
    >
      <Box
        maxW="1200px"
        width="100%"
        px={{ base: 0, md: 7 }}
        py={{ base: '4rem' }}
        mx="auto"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        minH="100vh"
        gridGap="16px"
        flexDir={{ base: 'column-reverse', lg: 'row' }}
      >
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1684476832-3d-view-with-icon.jpg`}
          alt="ScienceCreatingGoddessesSlide"
          width="100%"
          height="auto"
          maxW={{ base: '300px', sm: '330px', md: '596px' }}
          boxShadow="0px 9px 20px rgb(0 0 0 / 60%)"
          pt={{ base: '2rem', sm: '1rem' }}
          cursor="pointer"
          onClick={onOpen}
        />
        <Box maxW={{ sm: '300px', md: '596px' }}>
          <Text
            maxW={{ base: '13rem', sm: '19rem', lg: '23rem', xl: '26rem' }}
            color="#fff"
            fontSize={{ base: '18px', lg: '24px' }}
            textAlign="center"
          >
            {section?.sectionContent[0]?.text}
          </Text>
        </Box>
      </Box>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={useBreakpointValue({ base: 'full', md: '6xl' })}
        isCentered
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
        <ModalContent
          p={0}
          m="0"
          bg={{ base: '#000000' }}
          maxW={{ base: 'auto', md: '992px' }}
        >
          <ModalCloseButton
            _hover={{ bg: '#fff', color: '#000' }}
            _active={{ bg: '#fff', color: '#000' }}
            _focus={{ bg: '#fff', color: '#000' }}
            zIndex="20"
            top={{ base: '40px', md: '-5px' }}
            bg="#fff"
            color="#000"
            right={{ base: '3px', md: '-5px' }}
            rounded="full"
            // className={styles.closeButton}
          />
          <ModalBody p={0} m="0" w="100%" position="relative">
            <Box
              pos={{ base: 'static', md: 'static' }}
              left="50%"
              right="50%"
              // transform={{ md: 'none', base: 'translate(-50%, -50%)' }}
              display={{ base: 'flex', md: 'block' }}
              justifyContent={{ base: 'center' }}
              alignItems={{ base: 'center' }}
              h={{ base: '648px', md: '648px' }}
            >
              <Box
                bg="#FFFFFF"
                onClick={onClose}
                w="32px"
                h="32px"
                rounded="full"
                _hover={{ bg: '#FFFFFF' }}
                display={{ base: 'grid', md: 'none' }}
                placeItems="center"
                pos="absolute"
                top="-145px"
                left="-185px"
                fontFamily="FedraSansStd-Book"
                zIndex="10"
                cursor="pointer"
                color="black"
              >
                x
              </Box>

              <Box
                as="iframe"
                src={section?.sectionContent[1]?.linkUrl}
                w="100%"
                h={{ base: '100vh', md: '100%' }}
              ></Box>
            </Box>
            {/* </Box> */}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
export default AboutDeviSlide8;
